import Phaser from 'phaser';
import { useAuthStore } from '@/ui/stores/authStore';
import Image = Phaser.GameObjects.Image;
import Size = Phaser.Structs.Size;

export class SplashScene extends Phaser.Scene {
  private unsubscribeAuth?: () => void;

  private splash: Image | null = null;
  private title: Image | null = null;

  //private sessionToken: string | null = null;

  constructor() {
    super({ key: 'SplashScene' });
  }

  preload() {
    this.load.image('splash', '/assets/images/splash/splash.png');
    this.load.image('title', '/assets/images/splash/title.png');
  }

  create() {
    this.splash = this.add.image(0, 0, 'splash');
    this.title = this.add.image(0, 0, 'title');

    this.scale.on('resize', this.handleResize, this);
    this.handleResize(this.scale.gameSize, this.scale.baseSize, this.scale.displaySize);

    // Subscribe to auth store to reflect session status without using localStorage
    this.initAuthSubscription();
  }

  handleResize(gameSize: Size, _baseSize: Size, _displaySize: Size) {
    if (!this.splash || !this.title) return;

    const splashScale: number = Math.max(gameSize.height / this.splash.height, gameSize.width / this.splash.width);
    this.splash.setScale(splashScale, splashScale);
    this.splash.setOrigin(0.5, 0);
    this.splash.setPosition(gameSize.width/2, 0);

    const titleScale = Math.min(splashScale, gameSize.width / this.title.width);
    this.title.setOrigin(0.5, 0);
    this.title.setScale(titleScale, titleScale);
    this.title.setPosition(gameSize.width/2, 0);
  }

  private initAuthSubscription() {
    // Read initial state immediately
    //const currentState = useAuthStore.getState();
    //this.sessionToken = currentState.sessionToken;

    // Subscribe to future changes
    this.unsubscribeAuth = useAuthStore.subscribe((_state, _) => {
      //this.sessionToken = state.sessionToken;
    });

    // Clean up on scene shutdown/destroy
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.unsubscribeAuth?.());
    this.events.once(Phaser.Scenes.Events.DESTROY, () => this.unsubscribeAuth?.());
  }
}
